import { render, staticRenderFns } from "./table.vue?vue&type=template&id=07767ac0&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=07767ac0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07767ac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07767ac0')) {
      api.createRecord('07767ac0', component.options)
    } else {
      api.reload('07767ac0', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=07767ac0&scoped=true", function () {
      api.rerender('07767ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/hubInventoryBoard/table.vue"
export default component.exports